<template>
  <div id="page">
  <div id="outer">
    <div id="title-div">
      <div id="allSpan-div">
        <div id="span-div1">
          <span id="title-span">{{type==1?"学校标识码":"军校查询"}}</span>
        </div>
      </div>

      <div id="select-banner" style="width: 82%;margin-right: 56px;">
            <el-form :model="form" inline style="display: flex;align-items: center;" label-width="80px">
                <el-form-item label="院校名称" style="display: flex;">
                  <el-input placeholder="请输入院校名称" v-model="collegeName" @keyup.enter.native="getList()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="院校类型" v-if="type==7" style="display: flex;">
                  <el-select @change="getList()" v-model="form.type" placeholder="全部" size="small"  style="width:150px;" clearable>
                    <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="院校隶属" v-if="type==7" style="display: flex;">
                  <el-select @change="getList()" v-model="form.collegeAdmin" placeholder="全部" size="small"  style="width:150px;" clearable>
                    <el-option v-for="item in collegeAdminArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属省份" style="display: flex;">
                  <el-select v-model="form.collegeProvince" placeholder="全部" clearable @change="getList()" size="small"  style="width:120px;">
                    <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="院校性质" v-if="type==1" style="display: flex;">
                  <el-select v-model="collegeNature" placeholder="全部" clearable @change="getList()" size="small"  style="width:120px;">
                    <el-option v-for="item in collegeNatureArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="办学层次" v-if="type==1" style="display: flex;">
                  <el-select v-model="collegeLevel" placeholder="全部" clearable @change="getList()" size="small"  style="width:120px;">
                    <el-option v-for="item in ['本科','专科']" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="display: flex;">
                  <el-button type="success" size="small" @click="getList()">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
      </div>

      <div style="width:90%;height: 100%;overflow-y: auto;margin: 0 auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column prop="collegeName" label="学校名称" align="center">
          </el-table-column>
          <el-table-column prop="collegeCode" label="学校标识码" v-if="type==1" align="center"></el-table-column>
          <el-table-column prop="collegeNature" label="院校性质" v-if="type==1" align="center">
          </el-table-column>
          <el-table-column prop="collegeLevel" label="办学层次" v-if="type==1" align="center">
          </el-table-column>
          <el-table-column prop="collegeAdmin" label="院校隶属" v-if="type==7" align="center">
          </el-table-column>
          <el-table-column prop="type" v-if="type==7" label="院校类型" align="center">
          </el-table-column>
          <el-table-column prop="collegeProvince" label="所在省份" align="center">
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import { collegeBiaoshi,synthrsize_junxiao } from "@/api/gw/zonghe.js"
import cityJson from "@/utils/city.json"
export default{
  data(){
    return{
      cityData:cityJson,
      collegeName:"",//院校名称
       form:{
          type:"",//类型 军委直属院校 军事院校  军兵种院校 武警部队院校
					collegeProvince:"",//省份
					collegeAdmin:"",//院校隶属
       },
       collegeNature:"",
       collegeLevel:"",
       loading:false,
       list:[],
       typeArr:['军委直属院校','军事院校','军兵种院校','武警部队院校'],
      collegeAdminArr:["中央军委","陆军","空军","海军","火箭军","战略支援部队","武警"],
      collegeNatureArr:["公办","民办","中外合作办学及内地与港澳合作办学"],
    }
  },
  props:{
    type:{
      type:Number,
      default:1,//7军校查询
    }
  },
  watch:{
    type(){
      this.getList();
    },
  },
  mounted(){
this.getList();
  },
  methods:{
    getList(){
      this.loading = true
      this.list = [];
      if(this.type==1){
        collegeBiaoshi({
          collegeName:this.collegeName,
          limit:3000,
          collegeNature:this.collegeNature,
          collegeLevel:this.collegeLevel,
          collegeProvince:this.form.collegeProvince,
        }).then(res=>{
           this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      }else{
        let form = {...this.form};
        form["collegeName"] = this.collegeName
        synthrsize_junxiao(form).then(res=>{
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/components/biaoshi.vue